function upsertMeta(attr, key, content) {
  if (!content) return;
  let el = document.head.querySelector(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
}

// Sets the browser tab title + Open Graph / Twitter Card tags for the current page.
// Note: social crawlers (WhatsApp/X/Facebook) fetch raw HTML without running JS, so this
// mainly benefits real visitors (tab title) and JS-executing crawlers (e.g. Google).
export function setPageMeta({ title, description, image, url }) {
  if (title) document.title = title;
  upsertMeta("name", "description", description);
  upsertMeta("property", "og:title", title);
  upsertMeta("property", "og:description", description);
  upsertMeta("property", "og:image", image);
  upsertMeta("property", "og:url", url);
  upsertMeta("name", "twitter:title", title);
  upsertMeta("name", "twitter:description", description);
  upsertMeta("name", "twitter:image", image);
}
